import { escape, isFinite, isNil, toNumber } from 'lodash'
import { isExternalBookingSource } from '@tokeet/cost-resolver'
import type { BookingEngineCost } from '@tv3/models/inquiry/booking-engine-cost'
import type { Inquiry } from '@tv3/store/inquiry/inquiry.model'

export interface BookingAmountItem {
  name?: string
  amount?: number | string | null
  ignore?: number | boolean
}

// Channel bookings carry no reliable booking engine breakdown (the Vrbo base includes fees, the Airbnb cost
// is the payout), so the booking amount tokens resolve for direct bookings only.
export function getDirectBookingEngine(
  inquiry: Pick<Inquiry, 'inquirySource' | 'bookingEngine'> | null | undefined
): BookingEngineCost | undefined {
  return inquiry && !isExternalBookingSource(inquiry.inquirySource) ? inquiry.bookingEngine : undefined
}

export function formatBookingAmount(
  value: number | string | null | undefined,
  formatAmount: (value: number) => string
): string {
  const amount = toNumber(value)
  return isNil(value) || !isFinite(amount) ? '' : formatAmount(amount)
}

// Ignored booking fees stay on the booking for audit only, so they are skipped.
export function formatBookingItems(
  items: BookingAmountItem[] | null | undefined,
  formatAmount: (value: number) => string,
  plainText = false
): string {
  return (items || [])
    .filter((item) => !item.ignore)
    .map((item) => {
      const line = [item.name, formatBookingAmount(item.amount, formatAmount)].filter(Boolean).join(': ')
      return plainText ? line : escape(line)
    })
    .join(plainText ? '\n' : '<br />')
}
